import React, { Component } from "react";
import "../styling/App.css";
import styled from "styled-components";
import OurSlider from "./OurSlider";

const Eingaben = styled.div`
  font-size: 28px;
  line-height: 40px;
  margin-left: 24px;
  margin-top: 42px;
  color: #232a36;
  text-align: left;
  font-weight: bold;
  @media screen and (max-width: 640px) {
    font-size: 20px;
    line-height: 26px;
    margin-left: 16px;
  }
`;

const Spacer1 = styled.div`
  margin-bottom: 3rem;
  margin-top: -47px;
  @media screen and (max-width: 950px) {
    margin-top: 0;
  }
`;

class Input extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rechercheAufwand: 25,
      bruttoGehalt: 4000,
      wochenarbeitszeit: 40,
    };
  }

  componentDidMount() {
    this.props.onValueChange(this.state);
  }

  handleChange = (obj) => {
    this.setState(obj);
    this.props.onValueChange(this.state);
  };

  render() {
    return (
      <div>
        <Eingaben>Ihre Eingaben</Eingaben>
        <Spacer1>
          <OurSlider
            min={4}
            max={176}
            defaultValue={this.state.rechercheAufwand}
            unit="Stunden"
            explanatoryText="Aufwand für Recherchen und Schulungsvorbereitung pro Monat"
            onValueChange={(value) =>
              this.handleChange({ rechercheAufwand: value })
            }
          />

          <OurSlider
            min={0}
            step={50}
            max={8000}
            defaultValue={this.state.bruttoGehalt}
            unit="Euro"
            explanatoryText={"Bruttogehalt pro Monat"}
            onValueChange={(value) =>
              this.handleChange({ bruttoGehalt: value })
            }
          />

          <OurSlider
            min={4}
            max={60}
            defaultValue={this.state.wochenarbeitszeit}
            unit="Stunden"
            explanatoryText={"Wochenarbeitszeit"}
            onValueChange={(value) =>
              this.handleChange({ wochenarbeitszeit: value })
            }
          />
        </Spacer1>
      </div>
    );
  }
}

export default Input;
